import { addNewBlock, Block } from 'medium-draft';
import { AtomicBlockUtils, EditorState } from 'draft-js';
import { staticUrl } from '../../lib/config';

const insertMediaItem = (item, editor) => {
    const fileData = item;
    let editorState = editor;
    const content = editorState.getCurrentContent();

    fileData.type = item.type || item.fileType;
    if (fileData.type === 'video') {
        const contentWithEntity = content.createEntity(
            'video',
            'IMMUTABLE',
            {
                location: `${staticUrl}/${fileData.filename}`,
                edit: true,
                id: fileData.id,
                preview: fileData.preview,
            },
        );
        const entityKey = contentWithEntity.getLastCreatedEntityKey();
        editorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
        return AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, 'E');
    }
    if (fileData.type === 'image') {
        return addNewBlock(
            editorState,
            Block.IMAGE, {
                src: `${staticUrl}/${fileData.filename}`,
            },
        );
    }
    return '';
};

export const insertGallery = (items, editor) => {
    let editorState = editor;
    const content = editorState.getCurrentContent();

    const contentWithEntity = content.createEntity(
        'slider',
        'IMMUTABLE',
        {
            slides: items.map(i => ({
                ...i,
                previewUrl: `${staticUrl}/${i.filename}`,
                description: i.description
            }))
        },
    );
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    editorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
    return AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, 'E');
    // return addNewBlock(
    //     editor,
    //     editor.getSelection().getAnchorKey(),
    //     'SLIDER',
    //     new Map({
    //         slides: items.map(i => ({
    //             ...i,
    //             previewUrl: `${staticUrl}/${i.filename}`
    //         }))
    //     })
    // )
};

export default insertMediaItem;



// WEBPACK FOOTER //
// src/components/editor/insertMediaItem.js